import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
import { versionInfo } from "../../MainPage/VersionInfo";

export const NavrowStyle = () => {
  let isReVAMP = versionInfo.isReVAMP();
  return {
    navWrapper: {
      default: {
        color: basicColors.fourth,
        ":hover": {
          background: basicColors.fourth,
          color: basicColors.first,
          // ...(!islamp && { fontWeight: "bold" }),
        },
      },
      retro: {
        ...(isReVAMP && { paddingInline: "5px" }),
        color: isReVAMP ? "var(--sixth)" : "var(--second)",
        ":hover": {
          background: isReVAMP ? "var(--thirteenth)" : "var(--first)",
          color: isReVAMP ? "var(--sixth)" : "var(--second)",
        },
      },
      electric: {
        color: electricColors.second,
        ":hover": {
          background: electricColors.first,
          color: electricColors.second,
        },
      },
    },

    navElement: {
      default: {
        color: "inherit",
        fontSize: "14px",
        height: "40px",
        display: "flex",
        textDecoration: "none",
        padding: "8px 12px",
        cursor: "pointer",
        marginBottom: "1px",
      },
      retro: { ...(isReVAMP ? { color: "var(--eleventh)", padding: "0.50rem 0.5rem" } : { color: "var(--second)" }) },
      electric: { color: "var(--second)" },
    },
    navActive: {
      default: { background: basicColors.fourth, color: basicColors.first },
      retro: {
        ...(isReVAMP ? { background: "rgba(0, 0, 0, 0.5)", borderRadius: "15px" } : { color: "var(--second)", background: "var(--first)" }),
      },
      electric: { color: electricColors.second, background: electricColors.first },
    },
    navIconSize: {
      default: { size: 20 },
      retro: { size: 25 },
      electric: { size: 25 },
    },
  };
};

//export const



// WEBPACK FOOTER //
// ./src/components/SideNavBar/style/NavRow.jsx